import * as React from 'preact/compat'
import styles from '../../../css/game-series-scheme.pcss.json'
import GameSeries from '../SeriesEditor/GameSeries'
import { SeriesSchemeState } from './state'

interface PropTypes {
}

export default class SeriesCards extends React.Component<PropTypes, any> {
  static contextType = SeriesSchemeState
  declare context: React.ContextType<typeof SeriesSchemeState>
  seriesContainer = React.createRef<HTMLDivElement>()

  componentDidMount() {

  }

  render() {
    const { seriesInfo, relatedSeries } = this.context

    return <div className={styles['series-positioner']}>
      <div className={styles['main-series-card']}>
        <div id={`series_${seriesInfo.value.id}`} style='width: 224px; height: 248px' ref={this.seriesContainer}>
          <GameSeries series={seriesInfo.value} size={224} />
        </div>
        {relatedSeries.value.length > 0 && <div className={styles['related-series-container']}>
          {relatedSeries.value.map(seriesInfo => <div style='width: 224px'>
            <GameSeries series={seriesInfo} type='link' linkPostfix='' size={224} />
          </div>)}
        </div>}
      </div>
    </div>
  }
}
